import React from 'react';
import AsyncSelect from 'react-select/async';
import Axios from 'axios';
import { Layout } from '../../configs/ui/constant';
import { useTheme } from '@material-ui/core/styles';
import debounce from 'debounce-promise';
import { LogToBackend } from '../../configs/helpers/LogToBackend';

function SearchPosition(props) {
   const theme = useTheme();
   const {
      closeMenuOnSelect,
      onChange,
      isLoading,
      value,
      placeholder,
      isDisabled,
      defaultValue,
      defaultInputValue,
      name,
      title,
      options,
      alert,
      isMulti,
      onMenuOpen,
      defaultOptions,
      cacheOptions,
      inputValue,
      divisionId,
   } = props;
   const customStyles = {
      input: (base) => ({
         ...base,
         fontFamily: `'DBHeavent', sans-serif `,
         '& input': {
            font: 'inherit',
         },
      }),
      control: (base, state) => ({
         ...base,
         borderRadius: '5px',
         boxShadow: '',
         fontFamily: `'DBHeavent', sans-serif `,
         // minHeight: '2.2rem',
         '&:focus': {
            border: '1.25px solid',
            borderColor: Layout.primary,
            boxShadow: '',
         },
         '&:hover': {
            border: '1.25px solid',
            borderColor: state.isFocused ? Layout.primary : Layout.primary,
            boxShadow: '',
         },
         border: alert ? '1.25px solid red' : '1.25px solid #d3d2d1',
      }),
      menu: (base) => ({
         ...base,
         backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#FFFFFF',
         // borderRadius: "5px",
      }),
      menuList: (base) => ({
         ...base,
      }),
      singleValue: (base) => ({
         ...base,
      }),
      indicatorSeparator: (base) => ({
         ...base,
         display: 'none',
      }),
      dropdownIndicator: (base) => ({
         ...base,
      }),
      placeholder: (base) => ({
         ...base,
      }),
      container: (base) => ({
         ...base,
      }),
      menuPortal: (base) => ({
         ...base,
         zIndex: 999999,
      }),
   };
   const getData = (e) => {
      let resultDivisionId;
      if (divisionId) resultDivisionId = divisionId;
      else resultDivisionId = '';
      return new Promise((resolve, reject) => {
         Axios.get(
            `/GSB/dashboard/wallet/SearchPosition?keyword=${e}&affordable&excludeDivisionId=${resultDivisionId}`,
         )
            .then((resp) => {
               resolve(
                  resp.data.map((category, idx) => ({
                     data: category,
                     value: category.positionCode,
                     label: category.positionName,
                  })),
               );
            })
            .catch((err) => {
               LogToBackend(err);
               reject(err);
            })
            .finally(() => {});
      });
   };
   const loadOptions = (inputValue) => getData(inputValue);
   const debouncedLoadOptions = debounce(loadOptions, 1000, {
      leading: true,
   });
   return (
      <AsyncSelect
         styles={customStyles}
         onChange={onChange}
         loadOptions={(inputValue) => debouncedLoadOptions(inputValue)}
         placeholder={placeholder ? placeholder : 'ค้นหาตำแหน่ง'}
         // menuPortalTarget={document.querySelector("body")}
         defaultValue={defaultValue && defaultValue}
         defaultInputValue={defaultInputValue && defaultInputValue}
         defaultOptions={defaultOptions && defaultOptions}
         cacheOptions={cacheOptions && cacheOptions}
         inputValue={inputValue && inputValue}
         isDisabled={isDisabled}
         isClearable
      />
   );
}

export default SearchPosition;
